import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import BaiViet from './bai-viet';
import BaiVietDetail from './bai-viet-detail';
import BaiVietUpdate from './bai-viet-update';
import BaiVietDeleteDialog from './bai-viet-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={BaiVietUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={BaiVietUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={BaiVietDetail} />
      <ErrorBoundaryRoute path={match.url} component={BaiViet} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={BaiVietDeleteDialog} />
  </>
);

export default Routes;
